import React from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

import { FormContainer } from '@eika-kortbetjening/form-container';
import { CheckmarkList } from '@eika/checkmark-list';

import { getCloseCreditAccountUrl } from '@components/close-credit-account/functions';
import closeCreditAccountRoutes from '@components/close-credit-account/routes';
import Footer from '@components/footer/Footer';
import useText from '@hooks/use-text';

const WorthKnowing: React.FC = () => {
    const {
        worthKnowingHeader,
        worthKnowingSubHeader,
        worthKnowingInsurance,
        worthKnowingDigitalCard,
        worthKnowingDigitalWallet,
        worthKnowingValueProgram,
        worthKnowingIdInsurance,
    } = useText();
    const { chooseAccountUrl } = closeCreditAccountRoutes;

    const navigate = useNavigate();
    const [queryParams] = useSearchParams();

    const next = () => {
        navigate(getCloseCreditAccountUrl(queryParams, chooseAccountUrl), { relative: 'path' });
    };

    return (
        <FormContainer>
            <FormContainer.Content>
                <h3>{worthKnowingHeader}</h3>
                <CheckmarkList
                    uncheckedListLabel={worthKnowingSubHeader}
                    checkmarks={[
                        { label: worthKnowingInsurance, checked: false },
                        { label: worthKnowingDigitalCard, checked: false },
                        { label: worthKnowingDigitalWallet, checked: false },
                        { label: worthKnowingValueProgram, checked: false },
                        { label: worthKnowingIdInsurance, checked: false },
                    ]}
                />
            </FormContainer.Content>
            <FormContainer.Footer>
                <Footer next={next} />
            </FormContainer.Footer>
        </FormContainer>
    );
};

export default WorthKnowing;
